import * as ScanditSDK from 'scandit-sdk';

export const useScanditSettings = () => {
  const getScanSettings = () => {
    return new ScanditSDK.ScanSettings({
      enabledSymbologies: ['ean8', 'ean13', 'upca', 'code128', 'qr'],
      codeDuplicateFilter: 2500,
      searchArea: { x: 0.12, y: 0.38, width: 0.74, height: 0.35 },
      maxNumberOfCodesPerFrame: 1,
    });
  };

  return { getScanSettings };
};